<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/19nbw6O/tc-custom/scover.jpg?1685327666923?1723407505439" alt="This image is the cover for the book Frank's Place"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Frank's Place
      </h1>
      <p class="bookDescription body article font2">
        <p>Danny Marshall drops in on his favorite upscale gay bar, Frank’s Place, in hopes of finding Mr. Right or, if necessary, Mr. Right Now. With Christmas right around the corner, the place is nearly empty except for one man. Attractive by most standards but not Danny’s type, Danny decides what the hell and tries to score.<br/><br/>Even though the mysterious stranger isn't Danny's type, Danny finds himself falling for the man. But when the man disappears from the scene, Danny if left confused and frustrated.<br/><br/>Could this be the Mr. Right Danny has been searching for? Will Danny reconnect with the tall, handsome man? Can he discover the secret that caused the stranger to leave him hanging?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Terry O'Reilly
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      JMS Books LLC
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2cd84f36